import { Component, OnInit, ViewChild } from "@angular/core";
import { FormGroup, NgForm } from "@angular/forms";
import { DomSanitizer } from "@angular/platform-browser";
import { ActivatedRoute, ParamMap, Router } from "@angular/router";
import { Table } from "primeng/table";
import { environment } from "../../../../environments/environment";
import { ArkUserType, ClientFeatureSwitchViewModel, ClientModel, ClientViewModel } from "../../../core/api/models";
import { ClientsApiService } from "../../../core/api/services";
import { Utils } from "../../../core/utils";
import { AuthService } from "../../../main/auth.service";
import { AlertService } from "../../../shared/services/alert.service";

@Component({
  selector: 'app-client-features',
  templateUrl: './client-features.component.html',
  styleUrl: './client-features.component.css',
  standalone: false
})
export class ClientFeaturesComponent implements OnInit {


  public pageTitle: string = 'Features';

  itemFormGroup!: FormGroup;
  currentItem?: ClientModel;
  featureSwitches: ClientFeatureSwitchViewModel[] = [];
  loading: boolean = true;

  constructor(private authService: AuthService,
    private route: ActivatedRoute,
    private router: Router,
    private alertService: AlertService,
    private apiService: ClientsApiService,
    private sanitizer: DomSanitizer) {
  }


  ngOnInit(): void {


    this.route.paramMap.subscribe((params: ParamMap) => {
      let ID = + (params.get('ID') || '0');
      console.log(params);

      if (ID > 0) {
        console.info('Loading ' + ID);

        this.apiService.Get({ body: { id: ID } })
          .forEach(data => {
            this.loading = false;
            this.currentItem = data;

          }).catch(
            err => {
              this.alertService.error(Utils.getAjaxError(err));

            });

        this.apiService.GetClientFeatures({ body: { clientID: ID } })
          .forEach(data => {
            this.loading = false;
            this.featureSwitches = data;

          }).catch(
            err => {
              this.alertService.error(Utils.getAjaxError(err));

            });

      }
    });


    this.authService.checkIfAutorized([ArkUserType.Marketing, ArkUserType.Admin, ArkUserType.Impersonator]);

  }
  save() {
    this.loading = true;
    console.log('Saving feature switch data:', this.featureSwitches);
    
    this.apiService.SaveClientFeatureSwitches({
      clientID: this.currentItem?.ID ?? 0,
      body: this.featureSwitches
    })
      .subscribe(
        {
          next: (response) => {
            console.log('Update feature switch:', response);
            this.alertService.success(`Feature Switches saved successfully`);
            this.loading = false;
          },
          error: (error) => {
            console.error('Error updating feature switch:', error);
            this.alertService.error('Error updating feature switch - ' + error.Message);
            this.loading = false;
          }
        }
      );
  }
}
